import type { AppDispatch, RootState } from "@store/index";
import { extractPreconfiguredBaseId, syncDatasetBaseUsage } from "./dataset-base-usage-sync";
import { extractDatasetMetricIds, syncDatasetMetricUsage } from "./dataset-metric-usage-sync";

/** Reconciles both Dataset Base and Dataset Metric usage for one widget in a
 *  single call — every widget save/delete/duplicate/move site needs both, so
 *  this collapses the pair instead of repeating it at each call site in
 *  widget-api.ts. Pass configJson: null/undefined to clear the widget from
 *  both (deletion). */
export async function syncWidgetDatasetUsage(
  dispatch: AppDispatch,
  getState: () => RootState,
  datasetId: string | undefined | null,
  widgetId: string,
  dashboardId: string,
  configJson: string | undefined | null,
): Promise<void> {
  await syncDatasetBaseUsage(dispatch, getState, datasetId, [
    { widgetId, dashboardId, baseId: extractPreconfiguredBaseId(configJson) },
  ]);
  await syncDatasetMetricUsage(dispatch, getState, datasetId, [
    { widgetId, dashboardId, metricIds: extractDatasetMetricIds(configJson) },
  ]);
}
